namespace $.$$ {

	export class $shm_hitalama_process_logs_row extends $.$shm_hitalama_process_logs_row {

		process(): $shm_hitalama_process< any > | null {
			return null
		}

		@ $mol_mem
		children() {
			const process = this.process()
			if( !process ) return [] as $shm_hitalama_process< any >[]

			return this.$.$shm_hitalama_process.children( process )
		}

		@ $mol_mem
		child_rows() {
			return this.children().map( ( _, index )=> this.Child( index ) )
		}

		child_process( index: number ) {
			return this.children()[ index ] ?? null
		}

		status() {
			return this.process()?.data().status ?? 'pending'
		}

		name() {
			const process = this.process()
			if( !process ) return '-'

			const args = process.args.map( arg => this.short_value( arg ) ).join( ', ' )
			return `${ this.host_title( process.host ) }${ process.method_name }(${ args })`
		}

		host_title( host: object | undefined ) {
			if( !host ) return ''

			const full = `${ host }.`
			const widgets = [ ... full.matchAll( /(?:^|\.)(Widget<[^>]+>)(?=\.|$)/g ) ]
			const widget = widgets[ widgets.length - 1 ]
			if( widget ) return `${ widget[1] }.`

			return ''
		}

		started_at() {
			const data = this.process()?.data()
			return data?.started_at?.toString( 'hh:mm:ss' ) ?? '-'
		}

		duration() {
			const process = this.process()
			if( !process ) return '-'
			if( process.data().status === 'running' ) this.$.$mol_state_time.now( 250 )

			const duration = process.duration()
			if( duration < 1000 ) return `${ Math.round( duration ) } ms`
			if( duration < 60000 ) return `${ ( duration / 1000 ).toFixed( 1 ) } s`

			const minutes = Math.floor( duration / 60000 )
			const seconds = Math.floor(( duration - minutes * 60000 ) / 1000 )
			return `${ minutes } min ${ seconds } s`
		}

		children_visible() {
			return this.children().length ? super.children_visible() : []
		}

		short_value( value: unknown ) {
			if( typeof value === 'string' ) return JSON.stringify( value.length > 24 ? value.slice( 0, 21 ) + '...' : value )
			if( typeof value === 'number' || typeof value === 'boolean' || value === null ) return String( value )
			if( value === undefined ) return 'undefined'

			const title = ( value as { constructor?: { name?: string } } )?.constructor?.name
			return title && title !== 'Object' ? title : '{...}'
		}

	}

}
